/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */
import { NgModule } from '@angular/core';
import { ToggleDirective } from './password-show.directive';

@NgModule({
  declarations: [ToggleDirective],
  exports: [ToggleDirective]
})
export class PasswordShowModule {}
